import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CalendarComponent.css';

const CalendarComponent = ({ setDateValue, minDate }) => {

  // const tileContent = ({ date, view }) => {
  //   if (view === 'month') {
  //     return (
  //       <div className="dot-container">
  //         <span className="dot purple-dot"></span>
  //         <span className="dot blue-dot"></span>
  //         <span className="dot green-dot"></span>
  //       </div>
  //     );
  //   }
  // };

  return (
    <div className="calendar-container">
      <Calendar 
        onChange={setDateValue}
        locale="fr-FR" 
        // tileContent={tileContent}
        minDate={minDate}   

      />
    </div>
  );
};

export default CalendarComponent;